import React from 'react';
import { Container } from 'reactstrap'
import img from '../../assests/images/no-record.png'

const NoContentFound = (props) => (
    <Container>
        <div className={`text-center nodate-section ${props?.customClassName}`}>
            <img className={`hl-no-data-img ${props?.imagClass}`} alt={''} src={img} />
            <div className="my-2">
                <h5>{props?.title}</h5>
            </div>
        </div>
    </Container>
);


export default NoContentFound;